import { z } from "zod";

export const FAILURE_REPORT_ERROR_CODES = [
  "unauthorized",
  "forbidden",
  "not_found",
  "invalid_input",
  "validation_failed",
  "database_unavailable",
  "internal_error",
  "internal_server_error",
  "attachment_upload_failed",
  "catalog_unavailable",
  "directory_unavailable",
  "linear_unavailable",
  "upstream_unavailable",
  "service_unavailable",
  "form_version_changed",
  "form_unavailable",
  "request_failed",
  "network_error",
  "request_timeout",
  "invalid_response",
  "unknown_error",
] as const;

export const FailureReportInput = z
  .object({
    reportId: z.string().uuid(),
    occurredAt: z.string().datetime(),
    method: z.enum(["GET", "POST", "PUT", "PATCH", "DELETE", "HEAD", "OPTIONS"]),
    operation: z
      .string()
      .min(1)
      .max(200)
      .regex(/^\/[A-Za-z0-9/:_.*-]*$/),
    status: z.number().int().min(100).max(599).nullable(),
    errorCode: z.enum(FAILURE_REPORT_ERROR_CODES).optional(),
    durationMs: z.number().int().min(0).max(86_400_000),
    browser: z.enum(["Chrome", "Edge", "Firefox", "Safari", "Other"]),
    online: z.boolean(),
    correlationId: z.string().uuid().optional(),
  })
  .strict();
export type FailureReportInput = z.infer<typeof FailureReportInput>;

export const FailureReportingConfig = z.object({ teamId: z.string().uuid().nullable() }).strict();
export type FailureReportingConfig = z.infer<typeof FailureReportingConfig>;

export type FailureReportingSettings = FailureReportingConfig & { teams: Array<{ id: string; key: string; name: string }> };
export type FailureReportResponse = { issueId: string };
